<ap-selector-select
    [label]="'digipasSelector.label' | apContent"
    [options]="selectorOptions()"
    [formControl]="control()"
    [selectedOptions]="selectedOptions()"
    [selectionType]="selectionType"
    [multipleTitle]="'digipasSelector.multiple.title'"
    [multipleText]="'digipasSelector.multiple.text'"
    [messages]="messages"
    (clicked)="openModal()"
></ap-selector-select>
